import myAvatar from "../Components/Main/Photos/img photo/HairCrushJessDay3-1.jpeg";
const SEND_MESSAGE = 'SEND_MESSAGE';
const UPDATE_NEW_MESSAGE_BODY = 'UPDATE_NEW_MESSAGE_BODY';

let initialState = {
    icon: myAvatar,
    dialogs: [
        {
            id: 1, name: "Tommy Shelby", avatar: "https://i2-prod.liverpoolecho.co.uk/incoming/article23503282.ece/ALTERNATES/s1200c/1_Peaky-Blinders.jpg", messages: [
                { id: 0, time: '10:06', message: 'Oh! Relinquish is just a fancy word for lose!', src: "https://i2-prod.liverpoolecho.co.uk/incoming/article23503282.ece/ALTERNATES/s1200c/1_Peaky-Blinders.jpg"  },
                { id: 1, time: '10:14', message: 'HI, i have checked about your query, there is no any problem like that...', src: "https://www.layeredonline.com/wp-content/uploads/2018/07/HairCrushJessDay3-1.jpg" },
                { id: 2, time: '10:17', message: 'thank you for your quick reply, i am sending you a screenshot.', src: "https://i2-prod.liverpoolecho.co.uk/incoming/article23503282.ece/ALTERNATES/s1200c/1_Peaky-Blinders.jpg" },
                { id: 3, time: '10:28', message: "Yes, i have to see, please follow the below link.. https://www.abc.com", src: "https://www.layeredonline.com/wp-content/uploads/2018/07/HairCrushJessDay3-1.jpg" },
                { id: 4, time: '10:10', message: 'Dear You May again download the package directly...', src: "https://www.layeredonline.com/wp-content/uploads/2018/07/HairCrushJessDay3-1.jpg" },
                { id: 5, time: '08:40', message: 'Hi, mate! I have managed, thanks for your help. Cheers!', src: "https://i2-prod.liverpoolecho.co.uk/incoming/article23503282.ece/ALTERNATES/s1200c/1_Peaky-Blinders.jpg" }
            ]
        },
        {
            id: 2, name: 'Beth Harmon', avatar: "https://wallpapers.com/images/high/the-queen-s-gambit-beth-digital-fan-art-mdazcu7vb7ga4sss.jpg", messages: [
                { id: 0, time: '10:07', message: 'Get out and stop annoying me.', src: "https://www.layeredonline.com/wp-content/uploads/2018/07/HairCrushJessDay3-1.jpg" },
                { id: 1, time: '10:14', message: "Hi! How are you? Do you wanna play?", src: "https://wallpapers.com/images/high/the-queen-s-gambit-beth-digital-fan-art-mdazcu7vb7ga4sss.jpg" },
                { id: 2, time: '10:17', message: "You can change what you do, but you can't change what you want!", src: "https://wallpapers.com/images/high/the-queen-s-gambit-beth-digital-fan-art-mdazcu7vb7ga4sss.jpg" },
                { id: 3, time: '10:28', message: "We all mess up and do impure things. Doesn't mean we're bad people.", src: "https://www.layeredonline.com/wp-content/uploads/2018/07/HairCrushJessDay3-1.jpg" },
                { id: 4, time: '10:10', message: "Hey, if we're both going crazy, we'll go crazy together, right?", src: "https://wallpapers.com/images/high/the-queen-s-gambit-beth-digital-fan-art-mdazcu7vb7ga4sss.jpg" },
                { id: 5, time: '08:40', message: "I feel like I'm dreaming and I'm about to wake up.", src: "https://www.layeredonline.com/wp-content/uploads/2018/07/HairCrushJessDay3-1.jpg" }
            ]
        },
        {
            id: 3, name: 'Otis Milburn', avatar: "https://i.pinimg.com/564x/7e/89/c5/7e89c51d342ef0f5fee570eb87165b55.jpg", messages: [
                { id: 0, time: '08:01', message: 'That’s how it starts. I don’t need to eat the cake, I’ll just smell the icing.', src: "https://www.layeredonline.com/wp-content/uploads/2018/07/HairCrushJessDay3-1.jpg" },
                { id: 1, time: '08:12', message: 'I know you all hate me, and I’m sorry, but I don’t care.', src: "https://i.pinimg.com/564x/7e/89/c5/7e89c51d342ef0f5fee570eb87165b55.jpg" },
                { id: 2, time: '08:15', message: 'By the way, how did that feel, losing to a girl?', src: "https://www.layeredonline.com/wp-content/uploads/2018/07/HairCrushJessDay3-1.jpg" },
                { id: 3, time: '08:17', message: 'I hope by maid you mean mistress, because if some other woman was here cleaning...!', src: "https://i.pinimg.com/564x/7e/89/c5/7e89c51d342ef0f5fee570eb87165b55.jpg" },
                { id: 4, time: '08:29', message: 'Hello! How are you?', src: "https://i.pinimg.com/564x/7e/89/c5/7e89c51d342ef0f5fee570eb87165b55.jpg" },
                { id: 5, time: '08:30', message: 'Shut up! The camera adds ten pounds.', src: "https://www.layeredonline.com/wp-content/uploads/2018/07/HairCrushJessDay3-1.jpg" }]
        },
        {
            id: 4, name: "Monica Geller", avatar: "https://blogscdn.thehut.net/app/uploads/sites/35/2020/04/everyfriendsoutfit5_1585754531.jpg", messages: [
                { id: 0, time: '11:20', message: 'You don’t tell me what to do. I tell you what to do!', src: "https://blogscdn.thehut.net/app/uploads/sites/35/2020/04/everyfriendsoutfit5_1585754531.jpg" },
                { id: 1, time: '11:29', message: 'Now, I need you to be careful and efficient. And remember: If I am harsh with you, it’s only because you’re doing it wrong.', src: "https://www.layeredonline.com/wp-content/uploads/2018/07/HairCrushJessDay3-1.jpg" },
                { id: 2, time: '11:23', message: 'Why didn’t you make a copy and keep it in a fireproof box and keep it at least a hundred yards from the original?', src: "https://blogscdn.thehut.net/app/uploads/sites/35/2020/04/everyfriendsoutfit5_1585754531.jpg" },
                { id: 3, time: '11:27', message: 'Having a heart attack is nature’s way of telling you to slow down', src: "https://www.layeredonline.com/wp-content/uploads/2018/07/HairCrushJessDay3-1.jpg" },
                { id: 4, time: '13:01', message: 'Do you really think the best reason to get married is because you’re sorry?', src: "https://blogscdn.thehut.net/app/uploads/sites/35/2020/04/everyfriendsoutfit5_1585754531.jpg" },
                { id: 5, time: '13:05', message: 'Here’s the last of your boxes. I’m just going to label it ‘What were you thinking?', src: "https://www.layeredonline.com/wp-content/uploads/2018/07/HairCrushJessDay3-1.jpg" }
            ]
        },
        {
            id: 5, name: "Emily Cooper", avatar: 'https://pyxis.nymag.com/v1/imgs/720/78a/c64f539aa5d5cefac27ccd5b1b64e85a91-emily-in-paris.rsquare.w700.jpg',  messages: [
                { id: 0, time: '18:35', message: 'I wonder what age it is that you stop being able to put both legs behind your head.',  src: 'https://pyxis.nymag.com/v1/imgs/720/78a/c64f539aa5d5cefac27ccd5b1b64e85a91-emily-in-paris.rsquare.w700.jpg' },
                { id: 1, time: '18:50', message: 'We better stick to the routine; we don’t want to look stupid.', src: "https://www.layeredonline.com/wp-content/uploads/2018/07/HairCrushJessDay3-1.jpg" },
                { id: 2, time: '18:55', message: 'Why don’t you stop worrying about sounding smart and just be yourself.', src: 'https://pyxis.nymag.com/v1/imgs/720/78a/c64f539aa5d5cefac27ccd5b1b64e85a91-emily-in-paris.rsquare.w700.jpg' },
                { id: 3, time: '19:07', message: 'It’s never taken you more than a shower to get over a relationship.', src: "https://www.layeredonline.com/wp-content/uploads/2018/07/HairCrushJessDay3-1.jpg" },
                { id: 4, time: '19:09', message: 'Welcome to the real world. It sucks. You’re gonna love it.', src: "https://www.layeredonline.com/wp-content/uploads/2018/07/HairCrushJessDay3-1.jpg" },
                { id: 5, time: '19:11', message: 'He used to have this recurring nightmare. It really freaked him out...that I was going to eat him.', src: 'https://pyxis.nymag.com/v1/imgs/720/78a/c64f539aa5d5cefac27ccd5b1b64e85a91-emily-in-paris.rsquare.w700.jpg' }
            ]
        }
    ],
    newMessageBody: "",
}



const dialogsReducer = (state= initialState, action) => {
    switch (action.type) {
        case UPDATE_NEW_MESSAGE_BODY:
            return {
                ...state,
                newMessageBody: action.body
            };
        case SEND_MESSAGE:
            let body = state.newMessageBody;
            const date = new Date();
            const timeNow = date.toTimeString().split(' ')[0].split(':');
            const messageTime = timeNow[0] + ':' + timeNow[1];


            let newMessage = {
                id: state.dialogs[action.text].messages.length,
                time: messageTime,
                message: body,
                src: myAvatar
            }
            let newMessageState = {
                ...state.dialogs,
                ...state.dialogs[action.text],
                messages: [...state.dialogs[action.text].messages, newMessage],
                newMessageBody: ''
            }


            return {
                ...state,
                dialogs: state.dialogs.map(
                    dialog => dialog.id === Number(action.text)
                        ? {
                            ...dialog,
                            messages: newMessageState.messages
                        }
                        : dialog
                ),
                newMessageBody: ''
            };
        default:
            return state;
    }
}

export const sendMessageCreator = (text) => ({type: SEND_MESSAGE, text: text})

export const updateNewMessageBodyCreator = (body) => ({type: UPDATE_NEW_MESSAGE_BODY, body: body})

export default dialogsReducer;


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// const SEND_MESSAGE = "SEND_MESSAGE"
// const UPDATE_NEW_MESSAGE_BODY = 'UPDATE_NEW_MESSAGE_BODY'
// const SET_DIALOGS = "SET_DIALOGS"
//
// let initialState = {
//     dialogs: [],
//     newMessageBody: ""
// }
// const dialogsReducer = (state = initialState, action)=>{
//     switch (action.type){
//         case UPDATE_NEW_MESSAGE_BODY:
//             return {
//                 ...state,
//                 newMessageBody: action.body
//             }
//         case SEND_MESSAGE:
//             let body = state.newMessageBody
//             let copyState = {
//                 ...state, ...state.dialogs[action.count].returnMessages.push({message: body})
//             }
//             return {
//                 ...state, dialogs: [...copyState.dialogs], newMessageBody: ""
//             }
//         case SET_DIALOGS:{
//             return {...state, dialogs: [...action.dialogs]}
//         }
//         default: return state
//     };
// }
//
// export const updateNewMessageCreator = (body)=>{
//     return{
//         type: UPDATE_NEW_MESSAGE_BODY,
//         body
//     }
// }
// export const sendMessageCreator = (count)=>{
//     return{
//         type: SEND_MESSAGE,
//         count
//     }
// }
// export const setDialogsCreator = (dialogs) =>{
//     return{
//         type: SET_DIALOGS,
//         dialogs
//     }
// }
// export default dialogsReducer
//












